import React, { useContext } from "react";
import ListShares from "../Home/ListShares";
import { Tabs } from "./config";
import { MenusType } from "../../types";

interface IProps {
  defaultFilter: any;
  activeKey: Tabs;
}
export default function (props: IProps) {
  const { defaultFilter, activeKey } = props;
  return (
    <ListShares
      activeKey={activeKey}
      defaultFilter={defaultFilter}
      path={MenusType.TEAMSPACE}
      pagination={true}
    />
  );
}
